/**
 * First Sale Tracker Step Model
 *
 * Frontend model instance for the first_sale_tracker_steps table.
 * Represents a single step within a tracker (one of 8 sequential steps).
 */

import BaseModelInstance from './base.model'
import { FirstSaleTrackerStep as ModelDefinition } from './model-definitions'

class FirstSaleTrackerStep extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default FirstSaleTrackerStep
